import { Avatar, Box, Card, CardContent, Typography } from "@mui/material";

interface Props {
  children?: React.ReactElement<unknown>
  flows: Array<Flow>
  color?: 'light' | 'dark'
  noLine?: boolean
}

export default function Flow(props: Props) {
  return (
    <Box component={'ul'} sx={(theme) => ({
      padding: '0 1rem',
      listStyle: 'none',
      margin: 0,
    })}>
      {props.flows.map((f, index) => {
        return (
          <Box key={index} component={'li'} sx={(theme) => ({
            position: 'relative',
            ':not(:first-of-type)': {
              marginTop: '40px',
            },
            ':not(:first-of-type)&::after': {
              content: '""',
              position: 'absolute',
              top: '-40px',
              left: 0,
              right: 0,
              margin: 'auto',
              backgroundColor: theme.palette.primary.main,
              height: '40px',
              width: props.noLine ? '0px' : '5px',
              zIndex: 1
            }
          })}>
            <Card
              variant="outlined"
              sx={(theme) => ({
                position: 'relative',
                overflow: 'visible'
              })}
            >
              <Avatar
                sx={{
                  bgcolor: 'primary.main',
                  width: 40,
                  height: 40,
                  position: 'absolute',
                  top: -20,
                  left: -20
                }}
              >
                <Typography variant="h5" component="p" fontSize={'1.2rem'}>
                  {f.step}
                </Typography>
              </Avatar>
              <CardContent>
                <Typography variant="h5" gutterBottom fontWeight="bold">
                  {f.title}
                </Typography>
                {f.contents.map((c, ci) => {
                  return <Typography key={ci} variant="body1" color="text.secondary">{c}</Typography>
                })}
              </CardContent>
            </Card>
          </Box>
        )
      })}
    </Box>
  )
}